/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, Grid, InputLabel, OutlinedInput, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { LoadingPage } from '../../../../common/LoadingPage';
import { useSelector } from 'react-redux';
import { showNotification } from '../../../../common/Notification/ToastifyNotification';
import { apiRequest } from '../../../../common/common';

export default function CreateDialog({
    dialogOpen,
    setDialogOpen,
    selectedPage,
    categoryId,
    subCategoryId,
    onGridReady
}) {
    const { user } = useSelector((state) => state.users);
    const [dataLoading, setDataLoding] = useState(false);
    const [name, setName] = useState(null);
    const [prefix1, setPrefix1] = useState(null);
    const [prefix2, setPrefix2] = useState(null);
    const [errors, setErrors] = useState({});

    const getData = async () => {
        if (categoryId && Number(selectedPage) === 0 && dialogOpen) {
            try {
                const response = await apiRequest('get', `/category/${categoryId}`);
                if (response?.data) {
                    const { data } = response.data;
                    setName(data?.name);
                    setPrefix1(data?.prefix);
                    setPrefix2(data?.sku_no);
                }
            } catch (error) {
                showNotification(error?.response?.data.error || error.message, 'error');
            }
        } else if (subCategoryId && dialogOpen) {
            try {
                const response = await apiRequest('get', `/category/${subCategoryId}`);
                if (response?.data) {
                    const { data } = response.data;
                    setName(data?.name);
                    setPrefix1(data?.prefix);
                    setPrefix2(data?.sku_no);
                }
            } catch (error) {
                showNotification(error?.response?.data.error || error.message, 'error');
            }
        }
    }

    useEffect(() => {
        getData();
    }, [categoryId, subCategoryId]);

    const handleClose = () => {
        setName('');
        setPrefix1('');
        setPrefix2('');
        setErrors({});
        if (onGridReady) {
            onGridReady();
        }
        setDialogOpen(false);
    }

    const handleSubmit = async () => {
        const newErrors = {};

        if (!name) {
            newErrors.name = 'Name is required'
        }

        if (!prefix1) {
            newErrors.prefix1 = `${Number(selectedPage) === 0 ? 'Prefix1' : 'Prefix 3'} is required`
        }

        if (!prefix2) {
            newErrors.prefix2 = `${Number(selectedPage) === 0 ? 'Prefix2' : 'Prefix 4'} is required`
        }

        setErrors(newErrors);

        if (Object.keys(newErrors).length === 0) {
            const requestData = {
                name,
                prefix: prefix1,
                sku_no: prefix2,
                type: Number(selectedPage) === 0 ? 'category' : 'subCategory',
                is_show: true,
                user_id: user?.user_id
            };
            if (Number(selectedPage) === 0 && !categoryId) {
                setDataLoding(true);
                try {
                    const response = await apiRequest('post', '/category', requestData);
                    if (response?.data) {
                        setDataLoding(false);
                        showNotification(response?.data?.message, 'success');
                        handleClose();
                    }
                } catch (error) {
                    setDataLoding(false);
                    showNotification(error?.response?.data.error || error.message, 'error');
                }
            } else if (Number(selectedPage) === 0 && categoryId) {
                setDataLoding(true);
                try {
                    const response = await apiRequest('put', `/category/${categoryId}`, requestData);
                    if (response?.data) {
                        setDataLoding(false);
                        showNotification(response?.data?.message, 'success');
                        handleClose();
                    }
                } catch (error) {
                    setDataLoding(false);
                    showNotification(error?.response?.data.error || error.message, 'error');
                }
            } else if (Number(selectedPage) === 1 && (categoryId || localStorage.getItem('categoryId')) && !subCategoryId) {
                setDataLoding(true);
                try {
                    requestData.parent_id = categoryId || localStorage.getItem('categoryId');
                    const response = await apiRequest('post', `/category`, requestData);
                    if (response?.data) {
                        setDataLoding(false);
                        showNotification(response?.data?.message, 'success');
                        handleClose();
                    }
                } catch (error) {
                    setDataLoding(false);
                    showNotification(error?.response?.data.error || error.message, 'error');
                }
            } else if (subCategoryId) {
                setDataLoding(true);
                try {
                    requestData.parent_id = categoryId || localStorage.getItem('categoryId');
                    const response = await apiRequest('put', `/category/${subCategoryId}`, requestData);
                    if (response?.data) {
                        setDataLoding(false);
                        showNotification(response?.data?.message, 'success');
                        handleClose();
                    }
                } catch (error) {
                    setDataLoding(false);
                    showNotification(error?.response?.data.error || error.message, 'error');
                }
            }
        }
    }

    return (
        <Dialog open={dialogOpen} fullWidth maxWidth="sm">
            {dataLoading && <LoadingPage isLoading={dataLoading} />}
            <DialogTitle>{Number(selectedPage) === 0 ? categoryId ? 'Update Category' : 'Create Category' : subCategoryId ? 'Update SubCategory' : 'Create SubCategory'}</DialogTitle>
            <Divider />
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Name *</InputLabel>
                            <OutlinedInput
                                label="Name *"
                                id="standard-adornment-password"
                                type='text'
                                value={name || ''}
                                onChange={(e) => {
                                    const newErrors = errors;
                                    if (e.target.value) {
                                        newErrors.name = ''
                                    } else {
                                        newErrors.name = 'Name is required'
                                    }
                                    setErrors(newErrors);
                                    setName(e.target.value);
                                }}
                            />
                        </FormControl>
                        <Typography variant='body2' style={{ color: 'red' }}>{errors.name}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">{Number(selectedPage) === 0 ? 'Prefix 1' : 'Prefix 3'} *</InputLabel>
                            <OutlinedInput
                                label="Prefix 1 *"
                                id="standard-adornment-password"
                                type='text'
                                value={prefix1 || ''}
                                onChange={(e) => {
                                    const newErrors = errors;
                                    if (e.target.value) {
                                        newErrors.prefix1 = ''
                                    } else {
                                        newErrors.prefix1 = `${Number(selectedPage) === 0 ? 'Prefix1' : 'Prefix 3'} is required`
                                    }
                                    setErrors(newErrors);
                                    setPrefix1(e.target.value);
                                }}
                            />
                        </FormControl>
                        <Typography variant='body2' style={{ color: 'red' }}>{errors.prefix1}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">{Number(selectedPage) === 0 ? 'Prefix 2' : 'Prefix 4'} *</InputLabel>
                            <OutlinedInput
                                label="Prefix 2"
                                id="standard-adornment-password"
                                type='text'
                                value={prefix2 || ''}
                                onChange={(e) => {
                                    const newErrors = errors;
                                    if (e.target.value) {
                                        newErrors.prefix2 = ''
                                    } else {
                                        newErrors.prefix2 = `${Number(selectedPage) === 0 ? 'Prefix2' : 'Prefix 4'} is required`
                                    }
                                    setErrors(newErrors);
                                    setPrefix2(e.target.value);
                                }}
                            />
                        </FormControl>
                        <Typography variant='body2' style={{ color: 'red' }}>{errors.prefix2}</Typography>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="secondary" onClick={() => handleClose()}>
                    Cancel
                </Button>
                <Button variant="contained" color="primary" onClick={() => handleSubmit()}>
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    )
}